/**
 * رسوم التوصيل: 0 شيكل = توصيل مجاني (يُعرض)، وليس «بدون توصيل».
 * null/غير محدد = لا يوجد سطر توصيل.
 */

/** @param {unknown} raw */
export function parseStoredDeliveryFee(raw) {
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? Math.max(0, n) : null;
}

/** @param {Record<string, number>|null|undefined} prices @param {string} region */
export function deliveryFeeForRegion(prices, region) {
  const key = String(region || "").trim();
  if (!key) return null;
  const fee = Number(prices?.[key]);
  return Number.isFinite(fee) ? Math.max(0, fee) : 0;
}

/** @param {object|null|undefined} order */
export function orderIsDeliveryOrder(order) {
  const ot = String(order?.order_type || "").trim().toLowerCase();
  if (ot === "pickup" || ot === "dine_in") return false;
  if (ot === "delivery") return true;
  return order?.city_id != null || order?.cities?.id != null;
}

/** @param {object|null|undefined} order */
export function orderShowsDeliveryFeeRow(order) {
  if (!orderIsDeliveryOrder(order)) return false;
  if (parseStoredDeliveryFee(order?.delivery_fee) !== null) return true;
  return order?.city_id != null || order?.cities?.id != null;
}

/**
 * @param {object|null|undefined} order
 * @param {Record<string, number>|null|undefined} [deliveryPricesMap]
 * @param {boolean} [deliveryEnabled]
 */
export function orderDeliveryFeeAmount(order, deliveryPricesMap, deliveryEnabled = true) {
  const stored = parseStoredDeliveryFee(order?.delivery_fee);
  if (stored !== null && stored > 0) return stored;
  if (
    orderIsDeliveryOrder(order) &&
    deliveryEnabled !== false &&
    deliveryPricesMap &&
    typeof deliveryPricesMap === "object"
  ) {
    const region = order?.cities?.region;
    const computed = deliveryFeeForRegion(deliveryPricesMap, region);
    if (computed > 0) return computed;
  }
  if (stored !== null) return stored;
  if (orderShowsDeliveryFeeRow(order)) return 0;
  return 0;
}

/**
 * هل نعرض سطر التوصيل في ملخص السلة قبل إرسال الطلب؟
 */
export function checkoutShouldShowDeliveryFee({
  deliveryEnabled = true,
  orderType = "delivery",
  region = "",
  isRestaurant = false,
} = {}) {
  if (deliveryEnabled === false) return false;
  if (String(orderType || "").trim().toLowerCase() !== "delivery") return false;
  if (!isRestaurant && !String(region || "").trim()) return false;
  return true;
}
